import { render, staticRenderFns } from "./AccordionSustainability.vue?vue&type=template&id=758da0bd&"
import script from "./AccordionSustainability.vue?vue&type=script&lang=js&"
export * from "./AccordionSustainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports